import React, { useContext, useState } from 'react';
import NavHeader from '../../NavHeader';
import clsx from 'clsx';
import {
  makeStyles,
  createStyles,
  useTheme,
  createTheme
} from '@material-ui/core/styles'
import { Drawer, AppBar, useMediaQuery, CssBaseline, IconButton, Toolbar, Grid, Button } from '@material-ui/core';
import { Menu as MenuIcon, ExitToApp as ExitToAppIcon } from '@material-ui/icons';
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AppMenuDrawer } from './stylesDrawer';
import MenuDrawer from '../MenuDrawer';
import { Link } from 'react-router-dom';

const drawerWidth = 350;

const HeaderDrawer = ({ children }) => {
  const [open, setOpen] = useState(false);

  const themes = useContext(ThemeContext);
  const themess = useTheme();

  const themeWidth = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 1380,
        lg: 1380,
        xl: 1920
      }
    }
  });

  const mdUp = useMediaQuery(themeWidth.breakpoints.up('md'));

  //#region Material UI Styles
  const useStyles = makeStyles((theme) =>
    createStyles({
      grow: {
        flexGrow: 1
      },
      menuButton: {
        marginRight: theme.spacing(2)
      },
      title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
          display: 'block'
        }
      },
      inputRoot: {
        color: 'inherit'
      },
      sectionDesktop: {
        display: 'none',
        [themeWidth.breakpoints.up('md')]: {
          display: 'flex',
          marginTop: "15px"
        }
      },
      sectionMobile: {
        display: 'flex',
        [themeWidth.breakpoints.up('lg')]: {
          display: 'none'
        }
      },
      appBar: {
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }),
        border: '2px solid #E6E6E6',
        borderLeft: 'none',
        boxShadow: 'none',
        width: '100%'
      },
      appBarStudent: {
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }),

        borderLeft: 'none',
        boxShadow: 'none',
        height: '64px'
      },
      appBarShift: {
        height: '64px',
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen
        })
      },
      hide: {
        display: 'none'
      },
      drawer: {
        display: 'flex'
      },
      drawerOpen: {
        display: 'flex',
        flexDirection: 'column',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen
        }),
        backgroundColor: themes.primary,
        border: 'none',
        overflowX: 'hidden',
      },
      drawerClose: {
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
          width: '64px'
        },
        backgroundColor: themes.primary,
        border: 'none'
      },
      content: {
        flexGrow: 1,
        padding: theme.spacing(3)
      }
    })
  )
  //#endregion

  const classes = useStyles();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const logout = () => {
    localStorage.removeItem('token');
    window.open('/login', '_self');
  }

  return (
    <div>
      <div>
        <CssBaseline />

        <div className={classes.grow}>
          <AppBar
            position="fixed"
            style={{ backgroundColor: '#fff', height: '60px', boxShadow: '0px 2px 0px 0px rgba(114, 119, 128, 0.10)' }}
          >
            <div className={classes.sectionDesktop}>
              <NavHeader />
            </div>

            <div className={classes.grow} />

            <div className={classes.sectionMobile}>
              <Toolbar style={{ width: "100%", display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
                <IconButton
                  size="medium"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={!open ? handleDrawerOpen : handleDrawerClose}
                  style={{ border: 'none', outline: 'none' }}
                >
                  <MenuIcon />
                </IconButton>
                <Link to="/" style={{ marginLeft: '2.5rem' }}>
                  <img height={30} src={themes.logoImg} alt={themes.name} />
                </Link>

              </Toolbar>
            </div>
          </AppBar>
        </div>

        <div style={{ width: "100%" }} >
          {mdUp ? (
            <Drawer
              onMouseMove={handleDrawerOpen}
              onMouseLeave={handleDrawerClose}
              variant="permanent"
              className={clsx(classes.drawer, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open
              })}
              style={{ backgroundColor: `${themes.primary}` }}
              classes={{
                paper: clsx({
                  [classes.drawerOpen]: open,
                  [classes.drawerClose]: !open
                })
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
                <AppMenuDrawer>
                  {clsx({ [classes.drawerClose]: open }) ? (
                    <div className="img-plurall">
                      <img src={themes.smallLogo} height="60" />
                    </div>
                  ) : (
                    <div className="img-plurall-close">
                      <img src={themes.logoSideBar} height="30" />
                    </div>
                  )}

                  <div style={{ marginTop: "43px" }}>
                    <MenuDrawer drawer={clsx({ [classes.drawerClose]: !open })} leave={open} />
                  </div>
                </AppMenuDrawer>
              </div>
            </Drawer>
          ) : (
            <Drawer
              open={open}
              onClose={handleDrawerClose}
              variant="temporary"
              classes={{ paper: classes.drawerOpen }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
                <AppMenuDrawer>
                  {clsx({
                    [classes.drawerClose]: open
                  }) ? (
                    <div className="img-plurall">
                      <img
                        src={themes.smallLogo}
                        height="60"
                      />
                    </div>
                  ) : (
                    <div className="img-plurall-close">
                      <img
                        src={themes.logoSideBar}
                        height="30"
                        marginTop="30px"
                      />
                    </div>
                  )}

                  <div style={{ marginTop: "43px" }}>
                    <MenuDrawer drawer={clsx({ [classes.drawerClose]: !open })} leave={open} />
                  </div>
                </AppMenuDrawer>

                <Grid item container justifyContent="center" xs={12}>
                  <Grid item xs={12} className="menu-exam-mbile">
                    <Button
                      style={{
                        textAlign: 'left',
                        width: '100%',
                        justifyContent: 'flex-start',
                        borderRadius: '8px',
                        color: '#fff',
                        padding: '1rem',
                        fontWeight: 700,
                        marginTop: '-1rem'
                      }}
                      onClick={() => (logout())}
                      className="dropdown-toggle-container"
                    >
                      <ExitToAppIcon style={{ marginRight: '0.8rem' }} /> Sair
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Drawer>
          )}
        </div>
        <main className={classes.content} style={{ marginTop: "2rem" }}>{children}</main>
      </div>
    </div>
  );
};

export default HeaderDrawer;
